import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Fab, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useStyles, styles } from './styles';
import {
	getWatchList,
	setIsCreateRuleOpen,
	setRuleType,
	setIsNotificationOpen,
} from '../../redux/actions/createRuleActions';
import { useDispatch, useSelector } from 'react-redux';
import { HotSpotWithTooltip } from './FT-UX';
import { UserPortalContext } from '../../context/appcontext';
import { updateFTUXStoreValues } from './FT-UX/util';
import {
	THRESHOLD,
	RULE_NOTIFICATIONS,
	CREATE_RULE,
} from '../../constants/constant';
import Divider from '@mui/material/Divider';
import { colors } from '../../theme/color-palette';

const CreateRuleButton = ({ width }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const classes = useStyles();
	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);
	const { watchListData } = useSelector((state) => state.createRuleReducer);

	/**
	 * This is used to enable Custom Alert Tour guide experience
	 * If Watch list API return No data, the tour guides needs to be shown,
	 * but later this logic will move to a backend API service
	 */
	const showFtUxExperience = watchListData?.length === 0;
	useEffect(() => {
		if (showFtUxExperience) {
			updateFTUXStoreValues();
		} else {
			updateFTUXStoreValues(false);
		}
	}, [showFtUxExperience]);

	const handleAddIconClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => setAnchorEl(null);

	const onMenuItemClick = () => {
		setAnchorEl(null);
		// Opens Drawer
		dispatch(setRuleType(THRESHOLD));
		dispatch(setIsCreateRuleOpen(true));
	};

	const onNotificationClick = () => {
		setAnchorEl(null);
		dispatch(setIsNotificationOpen(true));
	};

	useEffect(() => {
		/**
		 * Triggers Get Watch list API,
		 * so the response will be used to show the FT UX tour guide
		 */
		dispatch(getWatchList({ portalUserContext }));
	}, []);

	return (
		<>
			{/* Plus Icon button */}
			<Fab
				id="find-add"
				color="primary"
				aria-label="add"
				size="small"
				sx={styles.plusButton}
				style={{
					backgroundColor: `${colors.PURPLE}`,
					borderRadius: '50%',
					color: `${colors.WHITE}`,
				}}
				onClick={handleAddIconClick}>
				{/* FT UX HotSpot w/ Tooltip */}
				<HotSpotWithTooltip show={showFtUxExperience} left={'-74%'} top={'-6%'}>
					<AddIcon />
				</HotSpotWithTooltip>
			</Fab>
			{/* Watch list Menu */}
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleMenuClose}
				PaperProps={{
					style: {
						width: width,
						marginTop: '5px',
					},
				}}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}>
				<MenuItem 
					id="close-menu"
					className={classes.menuItems} 
					onClick={onMenuItemClick}>
					{CREATE_RULE}
				</MenuItem>
				<Divider />
				<MenuItem 
					id="rule-notification-button"
					className={classes.menuItems} 
					onClick={onNotificationClick}>
					{RULE_NOTIFICATIONS}
				</MenuItem>
			</Menu>
		</>
	);
};

CreateRuleButton.propTypes = {
	drawerHandler: PropTypes.func,
	width: PropTypes.number,
	menuHandler: PropTypes.func,
};

export default CreateRuleButton;
